<template>
  <SustainabilityNavBar
    title="SUSTAINABILITY REPORT 2024"
    :sections="content"
  />
  <RecursiveJSONTemplate content-path="SustainabilityReport2024" />
</template>

<script>
import { mapActions } from "vuex";
import RecursiveJSONTemplate from "@/views/RecursiveJSONTemplate.vue";
import SustainabilityReportContent from "@/content/SustainabilityReport2024.json";
import SustainabilityNavBar from "@/components/sustainability/SustainabilityNavBar.vue";

export default {
  name: "SustainabilityReport2024",
  components: {
    RecursiveJSONTemplate,
    SustainabilityNavBar,
  },
  data() {
    return {
      content: SustainabilityReportContent,
    };
  },
  created() {
    const app = document.querySelector("#app");
    app.classList.remove("fixed-header");
  },
  mounted() {
    const url = new URL(window.location);
    const sectionSlug = url.searchParams.get("section");

    if (sectionSlug) {
      const matchedSection = this.content.find(
        (section) => section.slug === sectionSlug
      );

      window.addEventListener("load", () => {
        if (matchedSection) {
          this.updateSelectedSection({
            section: matchedSection.slug,
            navigate: true,
          });
        }
      });
    }
  },
  methods: {
    ...mapActions("sustainability", ["updateSelectedSection"]),
  },
};
</script>
